import { useRouter } from 'next/router'
import {
  EventActions,
  EventCategories,
  EventNames,
  sendDigitalDataEvent,
} from '@cinch-nx/shared-analytics'
import { track } from '@cinch-labs/customer-data-segment'
import {
  SectionWithImageV2,
  SectionWithImageV2Props,
} from '@cinch-nx/landing-ui-shared'

const aboutCollectionsPreferDeliveryCtaClick = (
  siteOrganisationalUnit: string,
) => {
  const evt = {
    event: {
      name: EventNames.click,
      category: EventCategories.button,
      action: EventActions.navigate,
      label: 'collection-locations-search-again-cta-click',
      value: siteOrganisationalUnit,
    },
  }

  sendDigitalDataEvent(evt)
  track('collection-locations-search-again-cta-click', evt)
}

export const SectionWithImageV2Wrapper: React.FC<SectionWithImageV2Props> = (
  props,
) => {
  const router = useRouter()

  const onClickHandler = () => {
    aboutCollectionsPreferDeliveryCtaClick(
      props.site?.getFeatureAttribute('organisationalUnit') ?? '',
    )
    router.push('/car-collections')
  }

  return <SectionWithImageV2 {...props} onButtonClick={onClickHandler} />
}
